import React, {useContext, useState} from "react";
import {CircularProgress, Divider, IconButton, InputBase, Paper, useTheme} from "@mui/material";
import {Close, Search} from "@mui/icons-material";
import {findDealRequest} from "../dealsApi";
import {DealsPageContext} from "../index";

export const FindDealComponent = () => {
  const [findLoad, setFindLoad] = useState(false);

  const {setDealsList, loadDealsData, setDisablePagination, resetOffset} = useContext(DealsPageContext);

  const findDeal = async (val) => {
    setFindLoad(true)

    const result = await findDealRequest(val)
    resetOffset();
    if (result.ok) {
      if (result?.data.length) {
        setDealsList(result?.data)
      } else {
        setDealsList([])
      }
    }
    setDisablePagination();
    setFindLoad(false)
  }

  return (<FindDealInput handleFind={findDeal} handleCancel={loadDealsData} loading={findLoad}/>)
}

export const FindDealInput = ({handleFind, handleCancel, loading}) => {
  const [val, setVal] = useState('');

  const theme = useTheme();

  const handleInput = (e) => {
    setVal(e.target.value)
  }

  const handleCancelClick = () => {
    setVal('');

    handleCancel ? handleCancel() : void 0;
  }

  const handleFindClick = () => {
    if(!val)
      return;

    handleFind(val)
  }

  return (
    <Paper
      component="div"
      sx={{
        p: '1px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
        height: '25px',
        border: '1px solid',
        borderColor: theme.palette.border.default
      }}
      elevation={0}
    >
      <InputBase
        sx={{ml: 1, flex: 1}}
        placeholder="Найти сделку"
        inputProps={{'aria-label': 'Найти сделку'}}
        onChange={handleInput}
        value={val}
        onKeyPress={(event) => {
          if (event.key === 'Enter')
            handleFindClick()
        }}
      />
      <IconButton type="button" sx={{p: '8px'}} aria-label="search" onClick={handleFindClick}>
        {loading ? <CircularProgress size="10px"/> : <Search sx={{color: theme.palette.icon.default}}/>}
      </IconButton>
      <Divider sx={{height: 28, m: 0.2}} orientation="vertical"/>
      <IconButton sx={{p: '8px'}} aria-label="directions">
        <Close sx={{color: theme.palette.icon.default}} onClick={handleCancelClick}/>
      </IconButton>
    </Paper>
  );
}
